import React, { Component } from 'react';
import Select from 'react-select';
import { Redirect } from 'react-router';
import Loader from '../../../Loader';
import EnhancedBloodPressure from './EnhancedBloodPressure';
import EnhancedThyroid from './EnhancedThyroid';
import EnhancedBloodSugar from './EnhancedBloodSugar';
import BootstrapTable from 'react-bootstrap-table-next';
import { thyroidColumns, bloodSugarColumns, bloodPressureColumns } from '../../Columns'

class AddVitals extends Component {

  state = {
    disease: '',
    records: []
  }

  componentDidMount() {
    
  }

  handleNewRecord = (record) => {
    this.setState(prevState => ({
      records: [...prevState.records, record]
    }))
  }

  render() {

    const { state } = this.props.location;
    const { records } = this.state;
    let columns;
    console.log(state);
    if(state == undefined) {
      return <Redirect to="/personalhealthrecord/pregnancyvitals"/>
    }

    if(state.value == 1) {
      columns = thyroidColumns;
    } else if(state.value == 2) {
      columns = bloodSugarColumns
    } else if(state.value == 3) {
      columns = bloodPressureColumns
    }
    

    return (
      <div className="my-3"> 
        <div className="row">
          <div className="col-md-4">
            <Select
              defaultValue={state}
              isDisabled
            />
          </div>
        </div>
        <div className="my-3">
          {state.value == 1 ? 
            <EnhancedThyroid formType="add" handleNewRecord={this.handleNewRecord} /> :
            state.value == 2 ? 
            <EnhancedBloodSugar formType="add" handleNewRecord={this.handleNewRecord} /> :
            <EnhancedBloodPressure formType="add" handleNewRecord={this.handleNewRecord} />
          }
        </div>
        {records.length > 0 &&
          <div>
            <h5>{`You have added ${records.length} records recently`}</h5>
            <BootstrapTable keyField="_id"
              data={records}
              columns={columns}
              wrapperClasses="table-responsive"
              headerClasses="tableHeader"
              />
          </div>
        }
      </div>
    )
  }

}

export default AddVitals;


// WEBPACK FOOTER //
// ./src/views/PersonalHealthRecord/PregnancyVitals/PregnancyVitalsView/AddVitals.js